import * as types from '../mutation-types'
import api from '@/api/ideas'
import router from "@/router";

// initial state
const state = {
    idea: [],
    loaded: false,
}

const getters = {
    idea: state => state.idea,
    ideaLoaded: state => state.loaded,
}

const actions = {
    getIdea({ commit }, params) {
        commit(types.SET_IDEA_LOADED, false );
        api.getIdeas(params, (response) => {
            if(!response._embedded.Post[0]) {
                router.push('/404')
            }
            commit(types.SET_IDEA, response._embedded.Post[0] );
            commit(types.SET_IDEA_LOADED, true );
        })
    },
}

const mutations = {
    [types.SET_IDEA] (state, idea ) {
        state.idea = idea ? idea : null
    },
    [types.SET_IDEA_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


